export function useRecaptcha()
{
    return {
        $recaptcha: useRecaptchaStore().helper
    };
}
